import {Component, Inject, OnInit} from '@angular/core';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { MatSnackBar } from "@angular/material/snack-bar";
import { constants } from 'src/app/shared/common/contants';
import { AsignUserRoleService } from 'src/app/shared/services/asign-user-role.service';
import { EtlService } from 'src/app/user/vault-data-migration-etl/etl.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {MigrationConfigComponentServices} from 'src/app/shared/services/Migrationconfiguration';
import { NewActionwithcheckboxComponent } from 'src/app/shared/common/Newsinglecheckbutton'
import { MatDialog } from '@angular/material/dialog';
import { TestbedpopupComponent } from 'src/app/user/mapping-testbed/testbedpopup/testbedpopup.component';
import { ActionwithcheckboxComponent } from 'src/app/shared/common/Actionwithcheckbox'
import { CustomtestBedComponent } from 'src/app/user/mapping-testbed/customtest-bed/customtest-bed.component'
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import {UserRoutingModule} from 'src/app/user/user-routing/user-routing.module';
import { ReportlinksserviceService } from 'src/app/user/reportlinks/reportlinksservice.service';



interface MappingTestbedComponentinfo {
  statusMessage: any,
  error: boolean,
  data: any
}



@Component({
    selector: 'app-mapping-testbed',
    templateUrl: './mapping-testbed.component.html',
    styleUrls: ['./mapping-testbed.component.scss'],
    standalone: false
})
export class MappingTestbedComponent implements OnInit {

    constructor(private dialog: MatDialog,private spinner:NgxUiLoaderService,private localStorageSettings: LocalStorageSettingsService,private snackbar: MatSnackBar,private constants: constants,private service:EtlService,private migrationconfigservices: MigrationConfigComponentServices,private userRoutingModule: UserRoutingModule,private reportLinkService:ReportlinksserviceService) {   }
    
  
    MigrationRow = []
    SetsRow = []
    backgroundColorButton = '';
    ObjectGrid :any;
    columnDefs
    columnDefsForObjects
    columnDefsForSelectedFields
    migrationIds
    setsids
    parentmigrationid
    SetsGrid
    defaultColDef
    paginationPageSize
    paginationNumberFormatter
    rowClassRules
    backgroundColorScreen
    totalpages
    currentpage
    buttonColor
    pagesize


    gridAPI;
    lastPage
    currentPage
    nextPage
    nextPagePlusOne
    totalPages
    getData
    gridColumnAPI
    RunpageSize
    RunpageSize1
    RuntotalPages1
    


    //svsfvsdvs
    rowSelectionForTablesFields
    columnDefsFormigration
    isRowSelectable
    value
    mgrstatus
    mgrstartdt
    mgrid
    isAddSets
    migrationDataLoadLogObject
    extractionCheckbox 
    globalCheckbox
    attachextractCheckbox
    ftpuploadCheckbox
    loadCheckbox
    transformationCheckbox
    validationCheckbox 
    preLoadTransformationCheckbox
    migrationType
    currentMigrationId
    
    tempdata :any=[];
    tempmgrndata:any=[];
    gridmgrnAPI
    gridApi
    gridmgrnData
    temprunHistory:any;
    gridAPIValidation
    gridDataValidation
    currentMigrationTraceIdInMigrationGrid
    rowSelection
    status
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    remarks
    tenantid
    retrivedsetids:any = [];
    refresh
    RunlastPage 
    RuncurrentPage
    RunnextPage 
    RunnextPagePlusOne 
    RuntotalPages
    RunlastPage1 
    RuncurrentPage1
    RunnextPage1 
    RunnextPagePlusOne1 
    insertObjects: any[] = [];
    isCustomTestBed: boolean = false;
    isdisable: boolean = false;
    buttonIdList:any = [];
    

    components = {
      buttonRenderer: Actionbutton,
    }

    columnDefsExtractTemp = [
          {
            headerName: 'Action', 
            filter: false, 
            pinned:'left',
            lockPinned:true, 
            cellRenderer: 'buttonRenderer',     
            cellRendererParams: {
              values: this.buttonIdList,
              delete: this.deleteIcon.bind(this),
              edit: this.editIcon.bind(this)
            }, width: 180
          },
          {
            headerName: 'Description',
            headerTooltip: 'Description',
            tooltipValueGetter: (params) => 'Description : ' + params.value,
            field: 'remarks',
            filter: 'agTextColumnFilter',
            width: 180
          },
          {
            headerName: 'Set Id',
            headerTooltip: 'Set Id..',
            tooltipValueGetter: (params) => 'Set Name. : ' + params.value,
            field: 'setid',
            filter: 'agTextColumnFilter',
            width: 120
          },
          {
            headerName: 'Run Instance',
            headerTooltip: 'Run Instance',
            tooltipValueGetter: (params) => 'Run Instance : ' + params.value,
            field: 'migrationid',
            filter: 'agTextColumnFilter',
            width: 180
          },
          {
            headerName: 'mappingtestbedid',
            headerTooltip: 'mappingtestbedid',
            tooltipValueGetter: (params) => 'mappingtestbedid : ' + params.value,
            field: 'mappingtestbedid',
            filter: 'agTextColumnFilter',
            width: 180
          },
          {
            headerName: 'status',
            headerTooltip: 'status',
            tooltipValueGetter: (params) => 'status : ' + params.value,
            field: 'status',
            filter: 'agTextColumnFilter',
            width: 180,
            cellStyle: function (params) {
              if (params.value == 'Yes') {
                return { color: 'green' };
              } else {
                return { color: 'red' };
              }
            }
          }          
        ]



    



    ngOnInit(){

      let screenPath = this.userRoutingModule.print(this.constructor.name);
    console.log(screenPath);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });

      this.backgroundColorButton = this.localStorageSettings.getSettings('ColorA');
      this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
      this.buttonColor = this.localStorageSettings.getSettings("ColorA");

  
      this.paginationPageSize = 10;

      this.paginationNumberFormatter = function (params) {
        return params.value.toLocaleString();
      };

      this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },

        sortable: true,
  
        resizable: true,
  
        filter: true
  
      };

      this.rowClassRules = {
        'rowBackgroundColor': function (params) {
          var numSickDays = params.node.data.status;
          return numSickDays === "No" || numSickDays === null;
        },
      };
      
    }

    refreshh(){
      this.isCustomTestBed =  false;
      this.retriveCheckBoxData();
      this.retrivedsetids = []
    }

    cellClickedObjects(event){
      
      this.refresh =event ;
      this.currentMigrationId = event.data.migrationId;
    
      this.service.retriveSetDetails(this.localStorageSettings.getSettings("dnsName"), this.currentMigrationId, "ETL").subscribe((val) => {
        this.gridDataValidation = [];
        this.gridDataValidation = val;
        this.retriveCheckBoxData();
      });
      
    }
    

    
     onGridReady(params) {
       this.gridAPI = params.api;
       this.getData = [];
       this.gridColumnAPI = params.columnApi;
     }   
      //this function is for going to the given page number
  onRunSearchChange(searchValue: number) {
    this.gridAPIValidation.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onRunPageSizeChanged(newPageSize) {
    var value = this.RunpageSize1;
    this.gridAPIValidation.setGridOption('paginationPageSize', Number(value));
  }





  onRunBtNext1() {
    console.log("next")
    this.gridAPIValidation.paginationGoToNextPage();
  }

  // below function for going to previous page
  onRunBtPrevious1() {
    console.log("previous")
    this.gridAPIValidation.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onRunBtFirst1() {
    this.gridAPIValidation.paginationGoToFirstPage();
  }

  // below function for going to last page
  onRunBtLast1() {
    this.gridAPIValidation.paginationGoToLastPage();
  }
   

  

  onloadPaginationChanged1(){
    if (this.gridAPIValidation) {
      this.RunlastPage1 = this.gridAPIValidation.paginationIsLastPageFound();
      this.RuncurrentPage1 = this.gridAPIValidation.paginationGetCurrentPage() + 1
      this.RunnextPage1 = this.gridAPIValidation.paginationGetCurrentPage() + 1 + 1
      this.RunnextPagePlusOne1 = this.gridAPIValidation.paginationGetCurrentPage() + 1 + 1 + 1
      this.RuntotalPages1 = this.gridAPIValidation.paginationGetTotalPages()
    }
  }

  onRunSearchChange1(searchValue: number) {
    this.gridmgrnAPI.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onRunPageSizeChanged1(newPageSize) {
    console.log(this.RunpageSize1)
    var value = this.RunpageSize1;
    this.gridmgrnAPI.onloadPaginationChanged1(Number(value));
  }

      

      retrieveInstructionsBasedOnActivity(params){
        this.gridAPIValidation = params.api;
        this.gridAPIValidation.setGridOption('rowData', [])
        this.retriveCheckBoxData()
      }

      onloadPaginationChanged(){

      }

      onCheckboxChangee(){
        // if(this.isCustomTestBed){
        //   this.isCustomTestBed=false;
        // }
        // else{
          this.isCustomTestBed=true;
        // }
      }


      
      
      
    


      Createtestbed() {
        console.log(this.retrivedsetids);
        console.log(this.isCustomTestBed)
        console.log(this.retrivedsetids.length)
        
       
          
        const dialogRef = this.dialog.open(CustomtestBedComponent, {
          panelClass: 'custom-dialog-container-materialFulfilment',
          width: '70%',
          height:'90%',
          autoFocus: false,
          disableClose: true,
        });

        dialogRef.afterClosed().subscribe((description: string) => {
          this.retrivedsetids = []
          this.refreshh();
        });

       
       
      }
      


      
     
      
      
    
      



      retriveCheckBoxData(){
      this.spinner.start();
      this.retrivedsetids = []
      const updatedList = [];
      this.migrationconfigservices.retrivemappingtestbedforattribute().subscribe((val) => {
        console.log("--------------------------")
        console.log(val)

        console.log("Updated list:", val);
        console.log(val)
        
        this.gridAPIValidation.setGridOption('rowData', val);

        

        
      });
      this.spinner.stop();
    }


  deleteIcon(e) {

      console.log(e)
    if (e.rowData.status == 'No' || e.rowData.status == null) {
      this.snackbar.open("Record Already Deleted", "OK", { duration: 5000 });
      return
    }
    
    this.spinner.start();
    if (confirm("Are you sure you want to delete the record ?") == true) {
      this.migrationconfigservices.DeleteFromtestbed(e.rowData.mappingtestbedid).subscribe((val) => {
        this.snackbar.open(val.data, "OK", { duration: 5000 });
        this.retriveCheckBoxData();
        this.refreshh();
      });
    }
    this.spinner.stop();
  }


  editIcon(e){

    const dialogRef = this.dialog.open(CustomtestBedComponent, {
      panelClass: 'custom-dialog-container-materialFulfilment',
      width: '70%',
      height:'90%',
      autoFocus: false,
      data: { edata: e.rowData},
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((description: string) => {
          this.retrivedsetids = []
          this.refreshh();
        });
    

  }



}
